import {
  IconPerson,
  IconWorkHome,
  IconConstruction,
  IconNotifications,
  IconFilledDatabase,
  IconChat,
  IconHostCompany,
  IconLearningContent,
} from "@/assets/icons";
import {
  AdminUserRoutes,
  AppRoutes,
  RsoManagementRoutes,
  CompanyManagementRoutes,
  SystemSettingRoutes,
  MasterDataRoutes,
  InformationRoutes,
  ChatRoutes,
  LearningContentRoutes,
} from "@/routes/config";
import { TMenu } from "@/types/menu";

// Get version from environment variable
const APP_VERSION = process.env.REACT_APP_VERSION || "0.1";

// Helper function to check if menu should be visible based on version
export const isMenuVisible = (minVersion?: string, maxVersion?: string): boolean => {
  if (!minVersion && !maxVersion) return true;

  const currentVersion = parseFloat(APP_VERSION);
  const min = minVersion ? parseFloat(minVersion) : 0;
  const max = maxVersion ? parseFloat(maxVersion) : Infinity;

  return currentVersion >= min && currentVersion <= max;
};

// Menu configuration with version-based visibility
// You can add minVersion and maxVersion to control when menu items are visible
// Example: visible: isMenuVisible("0.2") - only show from version 0.2 onwards
// Example: visible: isMenuVisible("0.1", "0.5") - show only between version 0.1 and 0.5
const menuConfig: TMenu[] = [
  {
    text: "顧客管理 (CS)",
    children: [
      {
        text: "登録支援機関管理",
        icon: IconWorkHome,
        path: AppRoutes.duringContractList,
        relatedRoutes: RsoManagementRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "受け入れ企業管理",
        icon: IconHostCompany,
        path: AppRoutes.companyDuringContractList,
        relatedRoutes: CompanyManagementRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "チャット管理",
        icon: IconChat,
        path: AppRoutes.chat,
        relatedRoutes: ChatRoutes,
        visible: isMenuVisible("1"),
      },
    ],
  },
  {
    text: "先生向け管理",
    children: [
      {
        text: "教材と試験情報",
        icon: IconLearningContent,
        path: AppRoutes.learningContent,
        relatedRoutes: LearningContentRoutes,
        visible: isMenuVisible("0.1"),
      },
    ],
  },
  {
    text: "システム管理",
    children: [
      {
        text: "irohana担当者",
        icon: IconPerson,
        path: AppRoutes.adminUser,
        relatedRoutes: AdminUserRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "お知らせ配信",
        icon: IconNotifications,
        path: AppRoutes.information,
        relatedRoutes: InformationRoutes,
        visible: isMenuVisible("1"),
      },
      {
        text: "マスターデータ管理",
        icon: IconFilledDatabase,
        path: AppRoutes.masterData,
        relatedRoutes: MasterDataRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "システム設定",
        icon: IconConstruction,
        path: AppRoutes.emailSetting,
        relatedRoutes: SystemSettingRoutes,
        visible: isMenuVisible("0.1"),
      },
    ],
  },
];

// Process menus to set visible property based on version
// If visible is not set, it defaults to true (menu will be shown)
export const menus: TMenu[] = menuConfig.map((menu) => ({
  ...menu,
  visible: menu.visible !== undefined ? menu.visible : true,
  children: menu.children?.map((child) => ({
    ...child,
    visible: child.visible !== undefined ? child.visible : true,
  })),
}));
